import React from 'react';
import '../styles/BrochurePage.css';

const BrochurePage = () => {
  return (
    <div className="brochure-container">
      <header className="brochure-header">
        <h1>라떼이즈 재취업 교육 및 경력 컨설팅 솔루션</h1>
        <p className="subtitle">음성 AI 기반 · 법적 의무 충족 · 맞춤형 경력 지원</p>
      </header>
      
      <main className="brochure-main">
        <section>
          <h2>서비스 개요</h2>
          <div className="intro-box">
            <p>음성 기반의 AI 컨설팅 서비스로 개인 맞춤형 컨설팅을 진행하며, 해당 컨설팅을 통해 경력 이력서 및 자소서를 자동 제공합니다.</p>
            <p>「근로자직업능력개발법」 준수 의무를 효율적으로 지원하는 재취업 교육 솔루션으로 법적 증빙 서류를 포함, HR 전용 관리자 대시보드도 제공합니다.</p>
            
          </div>
        </section>
        
        <section>
          <h2>서비스 구성</h2>
          <div className="service-grid">
            <div className="service-item">
              <h3>음성 기반 AI 컨설팅</h3>
              <ul>
                <li>실제 컨설턴트와의 대화 시뮬레이션</li>
                <li>경력 및 희망 직무(JD) 반영 맞춤형 질문</li>
                <li>높은 몰입도와 효과성</li>
              </ul>
            </div>
            <div className="service-item">
              <h3>자동 생성 결과물</h3>
              <ul>
                <li>국문/영문 이력서</li>
                <li>JD 맞춤형 자기소개서</li>
                <li>개인 웹 포트폴리오 (선택)</li>
              </ul>
            </div>
            <div className="service-item">
              <h3>법적 증빙 제공</h3>
              <ul>
                <li>재취업 교육 수료 리포트 발급</li>
                <li>성명, 사번, 교육 과정명, 이수 시간 포함</li>
                <li>기관장 날인 (대표이사 인감)</li>
              </ul>
            </div>
          </div>
        </section>
        
        <section>
          <h2>서비스 현황</h2>
          <div className="metrics-container">
            <div className="metric">
              <div className="metric-value">1,500+</div>
              <div className="metric-label">누적 사용자</div>
            </div>
            <div className="metric">
              <div className="metric-value">90%</div>
              <div className="metric-label">이력서 완성률</div>
            </div>
            <div className="metric">
              <div className="metric-value">95%</div>
              <div className="metric-label">사용자 만족도</div>
            </div>
          </div>
          <div className="validation-box">
            <p><strong>검증 및 인증</strong></p>
            <p>• 중소벤처기업부 예비창업패키지 선정 기업</p>
            <p>• 삼성전자, SK, 두산, LINE, CJ, 효성 등 대기업 인사 담당자 검증 완료</p>
            <p>• '음성 대화 기반 실시간 지능형 문서 생성 알고리즘' 특허 출원</p>
          </div>
        </section>
        
        <section>
          <h2>기업 패키지</h2>
          <div className="pricing-table">
            <div className="pricing-row">
              <div className="pricing-label">10인 패키지</div>
              <div className="pricing-value">연간 약 95만원 (20% 할인, VAT 별도)</div>
            </div>
            <div className="pricing-row">
              <div className="pricing-label">50인 이상</div>
              <div className="pricing-value">별도 협의</div>
            </div>
            <div className="pricing-row">
              <div className="pricing-label">100인 이상</div>
              <div className="pricing-value">별도 협의</div>
            </div>
          </div>
          <div className="benefits-box">
            <h4>공통 제공 사항</h4>
            <ul>
              <li>모든 Pro 기능 무제한 제공</li>
              <li>HR 전용 관리자 대시보드</li>
              <li>재취업 교육 수료 리포트 무료 제공</li>
              <li>계정 대량 발급 및 관리 지원</li>
            </ul>
          </div>
        </section>
        
        <section>
          <h2>도입 효과</h2>
          <ul className="effect-list">
            <li><strong>비용 절감</strong> 기존 컨설턴트 대비 1/10 로 비용 대폭 절감</li>
            <li><strong>효율성</strong> 온라인 즉시 교육으로 시간과 장소 제약 해소</li>
            <li><strong>법적 준수</strong> 교육생 및 관리자를 위한 수료 리포트 발급</li>
            <li><strong>관리 편의</strong> 대시보드를 통한 실시간 진행 현황 확인</li>
          </ul>
        </section>
        
        <section>
          <h2>도입 절차</h2>
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <strong>데모 계정 요청</strong>
                <span>기업 HR 담당자 확인용</span>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <strong>파일럿 운영</strong>
                <span>소규모 인원(10인) 테스트</span>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <strong>정식 계약</strong>
                <span>규모별 연간 패키지 적용</span>
              </div>
            </div>
          </div>
        </section>
        
        <section>
          <div className="contact-section">
            <h2>문의처</h2>
            <div className="contact-grid">
              <div className="contact-item">
                <span className="contact-label">대표</span>
                <span className="contact-value">홍선형</span>
              </div>
              <div className="contact-item">
                <span className="contact-label">이메일</span>
                <span className="contact-value"><a href="mailto:ceo@latteis.com">ceo@latteis.com</a></span>
              </div>
              <div className="contact-item">
                <span className="contact-label">연락처</span>
                <span className="contact-value"><a href="tel:010-7903-9697">010-7903-9697</a></span>
              </div>
              <div className="contact-item">
                <span className="contact-label">웹사이트</span>
                <span className="contact-value"><a href="https://www.latteis.com" target="_blank" rel="noopener noreferrer">www.latteis.com</a></span>
              </div>
            </div>
            <div className="company-info">
              <div className="company-info-item">
                <span className="info-label">법인명</span> 
                <span className="info-value">주식회사 갤럭시웨일 (Galaxy Whale Inc.)</span>
              </div>
              <div className="company-info-item">
                <span className="info-label">사업자등록번호</span> 
                <span className="info-value">629-88-03524</span>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default BrochurePage;